<div class="photo-container-height">
	<img [src]="data[index].photoUrl" alt="" class="photo-height" />
	<div class="arrow-row">
		@if (data.length > 1) {
			<mat-icon
				class="photo-gallery-navigation-icon"
				svgIcon="sl-left-caret"
				matTooltipDisabled="true"
				(click)="navigateLeft()"
				data-automation-id="gallery-navigate-left"
			></mat-icon>
		}

		<div class="photo-gallery-caption">{{ data[index].caption }}</div>

		@if (data.length > 1) {
			<mat-icon
				class="photo-gallery-navigation-icon"
				svgIcon="sl-right-caret"
				matTooltipDisabled="true"
				(click)="navigateRight()"
				data-automation-id="gallery-navigate-right"
			></mat-icon>
		}
	</div>
</div>
